import EmployeeLeaveRequestsView from '@/requests/leaves/views/user/listRequestLeave';
import { createFileRoute, redirect } from '@tanstack/react-router';


export const Route = createFileRoute('/_authenticated/requests/$id/leaves/')({
  beforeLoad: ({ context }) => {
    if (!context.user) throw redirect({ to: '/login' });
  },
  component: EmployeeLeaveRequestsView,
});

